import React from "react";

const OrderingProcess = () => {
  return (
    <div className="w-full bg-white py-10 sm:py-12 lg:py-14">
      <div className="mx-auto w-full max-w-[1600px] px-4 sm:px-6 lg:px-10">
        <div className="rounded-[24px] bg-gradient-to-br from-[#eef6ff] via-[#f8fafc] to-[#fff4e8] px-4 py-10 sm:px-6 sm:py-12 lg:px-10 lg:py-14">
          {/* Heading */}
          <div className="mb-8 text-center sm:mb-10">
            <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
              Our Ordering Process
            </h2>

            <div className="mx-auto mt-6 h-px w-full max-w-[620px] bg-[#9ca3af]"></div>

            <p className="mx-auto mt-5 max-w-[760px] text-[15px] font-medium leading-[26px] text-[#415164] sm:text-[16px]">
              Upload your artwork, approve your mockup, and receive your custom
              patch order with a smooth and professional process.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 xl:gap-6">
            {/* Card 1 */}
            <div className="group relative flex h-full min-h-[270px] flex-col rounded-[20px] border border-[#dbe7f3] bg-white px-5 py-6 shadow-[0_14px_35px_rgba(10,35,54,0.10)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-[#f97316]/50 hover:shadow-[0_20px_50px_rgba(10,35,54,0.16)]">
              <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#0a2336] text-[13px] font-extrabold text-white">
                01
              </div>

              <div className="mb-5 flex h-[78px] w-[78px] shrink-0 items-center justify-center rounded-[18px] bg-[#fff4e8] text-[#2563eb] ring-1 ring-[#f97316]/25 transition-all duration-300 group-hover:scale-105 group-hover:bg-[#f97316] group-hover:text-white sm:h-[84px] sm:w-[84px]">
                <svg viewBox="0 0 64 64" className="h-[43px] w-[43px]" fill="none">
                  <rect
                    x="10"
                    y="18"
                    width="44"
                    height="34"
                    rx="5"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    d="M18 44L28 34L36 41L43 33L54 46"
                    stroke="#f97316"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                  <circle
                    cx="24"
                    cy="28"
                    r="4"
                    fill="#f97316"
                    className="transition-all duration-300 group-hover:fill-white"
                  />
                  <path
                    d="M32 8V26M23 17L32 8L41 17"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <h3 className="mb-3 text-[17px] font-extrabold uppercase leading-[23px] text-[#0a2336] xl:text-[18px] xl:leading-[25px]">
                Upload Your Artwork & Order Online
              </h3>

              <p className="text-[14px] font-medium leading-[24px] text-[#4b5563] sm:text-[15px] xl:text-[16px] xl:leading-[25px]">
                Upload your design, select patch type, size, and quantity, and
                place your order online in just a few minutes, no emails or
                calls needed.
              </p>
            </div>

            {/* Card 2 */}
            <div className="group relative flex h-full min-h-[270px] flex-col rounded-[20px] border border-[#dbe7f3] bg-white px-5 py-6 shadow-[0_14px_35px_rgba(10,35,54,0.10)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-[#f97316]/50 hover:shadow-[0_20px_50px_rgba(10,35,54,0.16)]">
              <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#0a2336] text-[13px] font-extrabold text-white">
                02
              </div>

              <div className="mb-5 flex h-[78px] w-[78px] shrink-0 items-center justify-center rounded-[18px] bg-[#fff4e8] text-[#2563eb] ring-1 ring-[#f97316]/25 transition-all duration-300 group-hover:scale-105 group-hover:bg-[#f97316] group-hover:text-white sm:h-[84px] sm:w-[84px]">
                <svg viewBox="0 0 64 64" className="h-[43px] w-[43px]" fill="none">
                  <rect
                    x="14"
                    y="8"
                    width="36"
                    height="48"
                    rx="6"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    d="M23 24H41M23 34H38M23 44H32"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                  <path
                    d="M38 47L44 53L55 37"
                    stroke="#f97316"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                </svg>
              </div>

              <h3 className="mb-3 text-[17px] font-extrabold uppercase leading-[23px] text-[#0a2336] xl:text-[18px] xl:leading-[25px]">
                Review & Approve Your Patch Design
              </h3>

              <p className="text-[14px] font-medium leading-[24px] text-[#4b5563] sm:text-[15px] xl:text-[16px] xl:leading-[25px]">
                Review a digital mockup of your patch, request changes if
                needed, and approve the final design before production begins.
              </p>
            </div>

            {/* Card 3 */}
            <div className="group relative flex h-full min-h-[270px] flex-col rounded-[20px] border border-[#dbe7f3] bg-white px-5 py-6 shadow-[0_14px_35px_rgba(10,35,54,0.10)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-[#f97316]/50 hover:shadow-[0_20px_50px_rgba(10,35,54,0.16)]">
              <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#0a2336] text-[13px] font-extrabold text-white">
                03
              </div>

              <div className="mb-5 flex h-[78px] w-[78px] shrink-0 items-center justify-center rounded-[18px] bg-[#fff4e8] text-[#2563eb] ring-1 ring-[#f97316]/25 transition-all duration-300 group-hover:scale-105 group-hover:bg-[#f97316] group-hover:text-white sm:h-[84px] sm:w-[84px]">
                <svg viewBox="0 0 64 64" className="h-[43px] w-[43px]" fill="none">
                  <path d="M9 25H38V48H9V25Z" stroke="currentColor" strokeWidth="4" />
                  <path d="M38 33H49L57 42V48H38V33Z" stroke="currentColor" strokeWidth="4" />
                  <circle
                    cx="20"
                    cy="51"
                    r="5"
                    stroke="#f97316"
                    strokeWidth="4"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                  <circle
                    cx="48"
                    cy="51"
                    r="5"
                    stroke="#f97316"
                    strokeWidth="4"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                  <path
                    d="M18 15H39M18 15L26 8M18 15L26 22"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <h3 className="mb-3 text-[17px] font-extrabold uppercase leading-[23px] text-[#0a2336] xl:text-[18px] xl:leading-[25px]">
                We Produce & Ship Your Patch Order
              </h3>

              <p className="text-[14px] font-medium leading-[24px] text-[#4b5563] sm:text-[15px] xl:text-[16px] xl:leading-[25px]">
                We produce your custom patches with care and ship them quickly
                to your doorstep with full tracking.
              </p>
            </div>

            {/* Card 4 */}
            <div className="group relative flex h-full min-h-[270px] flex-col rounded-[20px] border border-[#dbe7f3] bg-white px-5 py-6 shadow-[0_14px_35px_rgba(10,35,54,0.10)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-[#f97316]/50 hover:shadow-[0_20px_50px_rgba(10,35,54,0.16)]">
              <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#0a2336] text-[13px] font-extrabold text-white">
                04
              </div>

              <div className="mb-5 flex h-[78px] w-[78px] shrink-0 items-center justify-center rounded-[18px] bg-[#fff4e8] text-[#2563eb] ring-1 ring-[#f97316]/25 transition-all duration-300 group-hover:scale-105 group-hover:bg-[#f97316] group-hover:text-white sm:h-[84px] sm:w-[84px]">
                <svg viewBox="0 0 64 64" className="h-[43px] w-[43px]" fill="none">
                  <path d="M18 15H46V52H18V15Z" stroke="currentColor" strokeWidth="4" />
                  <path d="M24 15V8H40V15" stroke="currentColor" strokeWidth="4" />
                  <path
                    d="M26 32H39M26 42H44"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                  <path
                    d="M13 52H51"
                    stroke="#f97316"
                    strokeWidth="4"
                    strokeLinecap="round"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                  <path
                    d="M47 25L54 18L58 22L51 29"
                    stroke="#f97316"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="transition-all duration-300 group-hover:stroke-white"
                  />
                </svg>
              </div>

              <h3 className="mb-3 text-[17px] font-extrabold uppercase leading-[23px] text-[#0a2336] xl:text-[18px] xl:leading-[25px]">
                Press at Your Pace And Store the Rest Forever
              </h3>

              <p className="text-[14px] font-medium leading-[24px] text-[#4b5563] sm:text-[15px] xl:text-[16px] xl:leading-[25px]">
                Apply your patches at your own pace using heat, sewing, or
                Velcro, and safely store any extras for future use.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderingProcess;